import { NgModule ,Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnterpriseComponent } from './enterprise.component';
import {DataTableModule} from 'angular2-datatable';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NotifierModule } from 'angular-notifier';
// import{sharedmodule} from '../Shared.module'
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
  MatSortModule, MatTableModule } from "@angular/material";

const routerConfig = [{
  path: '',
  component: EnterpriseComponent
}];

@NgModule({
  imports: [
    CommonModule,MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
    MatSortModule, MatTableModule,
    RouterModule.forChild(routerConfig),
    FormsModule,ReactiveFormsModule,DataTableModule,/*sharedmodule,*/UiSwitchModule,NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 12,
          gap: 10
        }
      },
      theme: 'material',
      behaviour: {
        autoHide: 2000,
        onClick: false,
        onMouseover: 'pauseAutoHide',
        showDismissButton: false,
        stacking: 1
      },
      animations: {
        enabled: true,
        show: {
          preset: 'slide',
          speed: 200,
          easing: 'ease'
        },
        hide: {
          preset: 'fade',
          speed: 300,
          easing: 'ease',
          offset: 50
        },
        shift: {
          speed: 300,
          easing: 'ease'
        },
        overlap: 150
      }
    })
  ],
  declarations: [
    EnterpriseComponent
    
    
 
  ],
  exports: [
    EnterpriseComponent
  ],
  providers: []
})


export class EnterpriseModule { }

